import type { KnowledgeQueryResult } from '@shared/knowledge';
import { SourceCard } from './SourceCard';

interface ChatMessageProps {
  role: 'user' | 'assistant';
  content: string;
  chunks?: KnowledgeQueryResult[];
  isLoading?: boolean;
}

export function ChatMessage({ role, content, chunks, isLoading }: ChatMessageProps) {
  const isUser = role === 'user';

  if (isLoading) {
    return (
      <div className="flex justify-start">
        <div className="max-w-[85%] rounded-2xl rounded-bl-md border border-border bg-card px-4 py-3 shadow-sm">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-kaiva-coral" />
            <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-kaiva-coral" style={{ animationDelay: '150ms' }} />
            <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-kaiva-coral" style={{ animationDelay: '300ms' }} />
            <span className="ml-1">Searching knowledge base...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-[85%] rounded-2xl px-4 py-3 shadow-sm ${
          isUser
            ? 'rounded-br-md bg-kaiva-coral text-white'
            : 'rounded-bl-md border border-border bg-card text-foreground'
        }`}
      >
        <p className="whitespace-pre-wrap text-sm leading-relaxed">{content}</p>

        {!isUser && chunks && chunks.length > 0 && (
          <div className="mt-3 space-y-2">
            <p className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
              Sources ({chunks.length})
            </p>
            {chunks.map((chunk, index) => (
              <SourceCard key={chunk.id} chunk={chunk} index={index} />
            ))}
          </div>
        )}

        {!isUser && chunks && chunks.length === 0 && (
          <p className="mt-2 text-xs italic text-muted-foreground">
            No matching sources found in the knowledge base.
          </p>
        )}
      </div>
    </div>
  );
}
